// Fallback site colors (the API provides colors, but these are defaults)
export const SITE_COLORS: Record<string, string> = {
  medalhas: '#f59e0b',
  chapas: '#3b82f6',
  backoffice: '#8b5cf6',
  chapa: '#6b7280',
};

export const TRAFFIC_CHANNEL_LABELS: Record<string, string> = {
  META_ADS: 'Meta Ads',
  GOOGLE_ADS: 'Google Ads',
  ORGANIC_SEARCH: 'Busca Orgânica',
  ORGANIC_SOCIAL: 'Social Orgânico',
  DIRECT: 'Direto',
  REFERRAL: 'Referência',
  EMAIL: 'E-mail',
  OTHER: 'Outro',
};

export const DEVICE_TYPE_LABELS: Record<string, string> = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
  Bot: 'Bot',
};

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

export function formatNumber(num: number): string {
  return num.toLocaleString('pt-BR');
}

export const CLIENT_TYPE_LABELS: Record<string, string> = {
  customer: 'Cliente',
  bot: 'Bot',
  scanner: 'Scanner',
  monitor: 'Monitor',
  unknown: 'Desconhecido',
};

export const REQUEST_CATEGORY_LABELS: Record<string, string> = {
  page: 'Página',
  api: 'API',
  static: 'Estático',
  image: 'Imagem',
  probe: 'Sonda',
  websocket: 'WebSocket',
  unknown: 'Outro',
};

export const COUNTRY_FLAGS: Record<string, string> = {
  BR: '🇧🇷', US: '🇺🇸', DE: '🇩🇪', FR: '🇫🇷', GB: '🇬🇧', JP: '🇯🇵', CN: '🇨🇳',
  IN: '🇮🇳', CA: '🇨🇦', AU: '🇦🇺', ES: '🇪🇸', IT: '🇮🇹', PT: '🇵🇹', MX: '🇲🇽',
  AR: '🇦🇷', CL: '🇨🇱', CO: '🇨🇴', RU: '🇷🇺', KR: '🇰🇷', NL: '🇳🇱', SE: '🇸🇪',
  NO: '🇳🇴', FI: '🇫🇮', DK: '🇩🇰', PL: '🇵🇱', BE: '🇧🇪', CH: '🇨🇭', AT: '🇦🇹',
  IE: '🇮🇪', NZ: '🇳🇿', SG: '🇸🇬', HK: '🇭🇰', TW: '🇹🇼', IL: '🇮🇱', ZA: '🇿🇦',
  UY: '🇺🇾', PY: '🇵🇾', PE: '🇵🇪', VE: '🇻🇪', EC: '🇪🇨', BO: '🇧🇴',
};

export const COUNTRY_NAMES: Record<string, string> = {
  BR: 'Brasil', US: 'EUA', DE: 'Alemanha', FR: 'França', GB: 'Reino Unido',
  JP: 'Japão', CN: 'China', IN: 'Índia', CA: 'Canadá', AU: 'Austrália',
  ES: 'Espanha', IT: 'Itália', PT: 'Portugal', MX: 'México', AR: 'Argentina',
  CL: 'Chile', CO: 'Colômbia', RU: 'Rússia', KR: 'Coreia do Sul', NL: 'Países Baixos',
  SE: 'Suécia', NO: 'Noruega', FI: 'Finlândia', DK: 'Dinamarca', PL: 'Polônia',
  BE: 'Bélgica', CH: 'Suíça', AT: 'Áustria', IE: 'Irlanda', NZ: 'Nova Zelândia',
  SG: 'Singapura', HK: 'Hong Kong', TW: 'Taiwan', IL: 'Israel', ZA: 'África do Sul',
  UY: 'Uruguai', PY: 'Paraguai', PE: 'Peru', VE: 'Venezuela', EC: 'Equador', BO: 'Bolívia',
};

export function formatResponseTime(seconds: number): string {
  if (seconds < 0.001) return '<1ms';
  if (seconds < 1) return `${Math.round(seconds * 1000)}ms`;
  return `${seconds.toFixed(2)}s`;
}

export function getCountryFlag(code: string | null | undefined): string {
  if (!code) return '🌐';
  return COUNTRY_FLAGS[code.toUpperCase()] || '🏳️';
}

export function getCountryName(code: string | null | undefined): string {
  if (!code) return 'Desconhecido';
  return COUNTRY_NAMES[code.toUpperCase()] || code.toUpperCase();
}
